import React from 'react';

const Location = () => {
  return (
    <div className="container-fluid py-5  text-black">
      <div className="container">
        <h4 className="text-black mb-4">Emperia Icon</h4>
        <p><i className="fa fa-map-marker-alt me-2"></i> D 113, opp. DY Patil Stadium, MIDC Industrial Area, Nerul, Navi Mumbai, Maharashtra 400706</p>
        <div style={{ overflow: "hidden", paddingBottom: "56.25%", position: "relative", height: 0 }}>
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.423586715043!2d73.0153054751073!3d19.036209947264953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c5bcd1d1d0f3%3A0xf7d0b522a9632c17!2sDY%20Patil%20Stadium%2C%20Nerul%2C%20Navi%20Mumbai%2C%20Maharashtra%20400706!5e0!3m2!1sen!2sin!4v1692907042453!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0, position: "absolute", top: 0, left: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Location;
